import React from 'react';
import styled from 'styled-components';
import { Select, FormLabel as Label } from '~ui-kit';

const SelectWithCount = ({
  value,
  onChange,
  options,
  label,
  required,
  error,
}) => {
  return (
    <Wrapper>
      <SelectContainer>
        <Label required={required}>{label || 'Valinta'}</Label>
        <StyledSelect
          error={error}
          options={options}
          value={value.id}
          onChange={v => onChange({ ...value, id: v })}
          placeholder="Valitse"
          noErrorLabel
        />
      </SelectContainer>
      <CountContainer>
        <Label>Kpl</Label>
        <Count
          error={error}
          className="form-control"
          type="number"
          min="1"
          value={value.itemCount}
          onChange={e => onChange({ ...value, itemCount: e.target.value })}
        />
      </CountContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

const StyledSelect = styled(Select)``;

const Count = styled.input`
  height: 42px;
  width: 80px;
`;

const SelectContainer = styled.div`
  flex-grow: 1;
`;

const CountContainer = styled.div`
  margin-left: 16px;
`;

export default SelectWithCount;
